import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#D67D00",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="12" cy="12" r="12"/> <path fill="#fff" d="M11.28 14.07h1.44l.32-3.52v-4.4h-2.08v4.4zm-.32 3.28h2.08v-2.24h-2.08z"/>' }
  })
);